export default __webpack_public_path__ + "5a104d1d5d84de28ae81d7b593f94fc7.png";